import { render, staticRenderFns } from "./ManualDeviceTable.vue?vue&type=template&id=8b84497e&"
import script from "./ManualDeviceTable.vue?vue&type=script&lang=ts&"
export * from "./ManualDeviceTable.vue?vue&type=script&lang=ts&"
import style0 from "./ManualDeviceTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports